import { useEffect, useState } from 'react';

import { Cancel01Icon, FileEmpty01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';

export const CsvTableDetails = ({ csvData, fileName, className, onDrop = () => {} }) => {
  const [headers, setHeaders] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!csvData || csvData.length < 1) return;
    const rawRows = csvData.slice(1) || [];
    const nonEmpty = (rawRows || []).filter(
      row => Array.isArray(row) && row.some(cell => cell != null && String(cell).trim() !== ''),
    );
    setHeaders(csvData[0] || []);
    setData(nonEmpty);
  }, [csvData]);

  const headersList = Array.isArray(headers) ? headers : [];
  const dataList = Array.isArray(data) ? data : [];

  return (
    <div className={cn('w-full', className)}>
      <div className="flex items-center justify-between mb-2 text-xl">
        <div className="flex items-center gap-1.5 text-grey-50">
          <HugeiconsIcon icon={FileEmpty01Icon} size={18} strokeWidth={1.5} />
          {fileName && (
            <span className="font-medium text-text-primary max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap">
              {fileName}
            </span>
          )}
          <span className="text-grey-35" data-testid="csv-table-row-count">
            {dataList.length} {dataList.length === 1 ? 'candidate' : 'candidates'}
          </span>
        </div>
        <button
          type="button"
          className="flex items-center gap-0.5 bg-transparent border-0 p-0 cursor-pointer text-grey-35 hover:text-status-error"
          onClick={onDrop}>
          <HugeiconsIcon icon={Cancel01Icon} size={16} strokeWidth={1.5} />
          Remove CSV
        </button>
      </div>
      <div className="w-full max-h-[300px] overflow-auto rounded-lg border border-border-primary shadow-[0_2px_8px_rgba(0,0,0,0.06),0_1px_2px_rgba(0,0,0,0.04)] bg-white [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-track]:bg-surface-secondary [&::-webkit-scrollbar-thumb]:rounded-sm [&::-webkit-scrollbar-thumb]:bg-neutral-5">
        <div className="inline-block min-w-full">
          <table className="w-max min-w-full table-auto border-collapse bg-white box-border">
            <thead className="sticky top-0 z-[1] bg-surface-secondary text-text-primary">
              <tr>
                {headersList.map(header => (
                  <th key={header} className="whitespace-nowrap py-2.5 px-4 text-xl">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dataList.map((row, rowIndex) => (
                <tr key={rowIndex} className="border-b border-border-primary last:border-b-0">
                  {(Array.isArray(row) ? row : []).map((column, colIndex) => (
                    <td key={colIndex} className="whitespace-nowrap py-2.5 px-4 text-xl">
                      {column}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
